import React from 'react';
import './LegalPage.css';

export default function TermsConditions() {
  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Legal</span>
          <h1>Terms & <span>Conditions</span></h1>
          <p>Last updated: March 13, 2025</p>
        </div>
      </section>

      <section className="section">
        <div className="container legal-container">
          <div className="legal-sidebar">
            <h4>Contents</h4>
            <ul>
              <li><a href="#acceptance">Acceptance of Terms</a></li>
              <li><a href="#services">Services Description</a></li>
              <li><a href="#engagement">Engagement Terms</a></li>
              <li><a href="#ip">Intellectual Property</a></li>
              <li><a href="#confidentiality">Confidentiality</a></li>
              <li><a href="#payment">Payment Terms</a></li>
              <li><a href="#warranties">Warranties & Disclaimers</a></li>
              <li><a href="#liability">Limitation of Liability</a></li>
              <li><a href="#termination">Termination</a></li>
              <li><a href="#governing">Governing Law</a></li>
            </ul>
          </div>

          <div className="legal-content">
            <div className="legal-intro">
              <p>
                These Terms and Conditions ("Terms") constitute a legally binding agreement between Rocket On Time ("Company", "we", "us", or "our") and you ("Client", "you", or "your") governing your use of our website and engagement of our technology services.
              </p>
              <p>
                Please read these Terms carefully before engaging our services. By engaging Rocket On Time, signing a Statement of Work, or using our website, you agree to be bound by these Terms.
              </p>
            </div>

            <div className="legal-section" id="acceptance">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing our website or engaging our services, you confirm that you:</p>
              <ul>
                <li>Are at least 18 years of age or have the legal capacity to enter into contracts.</li>
                <li>Have the authority to bind yourself or your organization to these Terms.</li>
                <li>Have read, understood, and agree to be bound by these Terms and our Privacy Policy.</li>
              </ul>
              <p>We reserve the right to modify these Terms at any time. Continued use of our services following notification of changes constitutes your acceptance.</p>
            </div>

            <div className="legal-section" id="services">
              <h2>2. Description of Services</h2>
              <p>Rocket On Time provides technology services including but not limited to:</p>
              <ul>
                <li>Custom software development and application engineering</li>
                <li>IT consulting and strategic advisory services</li>
                <li>Cloud solutions, migration, and DevOps services</li>
                <li>Cybersecurity assessments and implementation</li>
                <li>Data analytics, business intelligence, and reporting</li>
                <li>Mobile application development</li>
                <li>Technology training and knowledge transfer</li>
              </ul>
              <p>The specific scope of services for each engagement will be defined in a separate Statement of Work (SOW) or Service Agreement, which forms part of and is subject to these Terms.</p>
            </div>

            <div className="legal-section" id="engagement">
              <h2>3. Engagement Terms</h2>
              <h3>3.1 Statements of Work</h3>
              <p>Each project engagement will be governed by a Statement of Work (SOW) that specifies deliverables, timelines, milestones, and pricing. SOWs are binding documents that become effective upon execution by both parties.</p>

              <h3>3.2 Client Responsibilities</h3>
              <p>You agree to:</p>
              <ul>
                <li>Provide timely access to necessary personnel, systems, and information.</li>
                <li>Designate a qualified project point of contact.</li>
                <li>Review and approve deliverables within agreed timeframes.</li>
                <li>Provide feedback in a constructive and timely manner.</li>
                <li>Ensure all information provided is accurate and complete.</li>
              </ul>

              <h3>3.3 Change Requests</h3>
              <p>Any changes to agreed scope must be documented in a written Change Request. Rocket On Time reserves the right to adjust timelines and costs for approved scope changes.</p>
            </div>

            <div className="legal-section" id="ip">
              <h2>4. Intellectual Property</h2>
              <h3>4.1 Work Product Ownership</h3>
              <p>Upon full payment of all fees, all custom work product created specifically for you under a SOW ("Deliverables") shall be owned by you. Rocket On Time assigns all rights, title, and interest in such Deliverables to you.</p>

              <h3>4.2 Rocket On Time Property</h3>
              <p>Rocket On Time retains ownership of:</p>
              <ul>
                <li>Pre-existing intellectual property, tools, frameworks, and methodologies.</li>
                <li>General knowledge, skills, and experience developed during engagements.</li>
                <li>Proprietary software libraries incorporated into Deliverables (subject to license grants).</li>
              </ul>

              <h3>4.3 Third-Party Components</h3>
              <p>Deliverables may incorporate open-source or third-party licensed components. Rocket On Time will disclose such components and their applicable licenses.</p>
            </div>

            <div className="legal-section" id="confidentiality">
              <h2>5. Confidentiality</h2>
              <p>Both parties agree to maintain strict confidentiality regarding non-public information disclosed during the engagement ("Confidential Information"). This obligation:</p>
              <ul>
                <li>Survives the termination of our engagement for a period of 5 years.</li>
                <li>Excludes information that becomes publicly available through no breach of this agreement.</li>
                <li>Excludes information independently developed or received from a third party without restriction.</li>
              </ul>
              <p>Rocket On Time will sign a separate Non-Disclosure Agreement (NDA) upon request prior to commencing any engagement.</p>
            </div>

            <div className="legal-section" id="payment">
              <h2>6. Payment Terms</h2>
              <h3>6.1 Fees</h3>
              <p>Fees are specified in the applicable SOW. Unless otherwise stated, fees are quoted in Indian Rupees (INR) exclusive of applicable taxes.</p>

              <h3>6.2 Payment Schedule</h3>
              <ul>
                <li>Fixed-price projects: Typically 30% upfront, 40% at midpoint, 30% upon delivery.</li>
                <li>Time-and-material engagements: Monthly invoicing with 30-day payment terms.</li>
                <li>Retainer arrangements: Invoiced at the start of each retainer period.</li>
              </ul>

              <h3>6.3 Late Payments</h3>
              <p>Invoices not paid within 30 days of the due date will incur interest at 1.5% per month. Rocket On Time reserves the right to suspend services for overdue accounts.</p>

              <h3>6.4 Taxes</h3>
              <p>Client is responsible for all applicable taxes (GST, withholding tax, etc.) unless otherwise specified in the SOW.</p>
            </div>

            <div className="legal-section" id="warranties">
              <h2>7. Warranties & Disclaimers</h2>
              <h3>7.1 Our Warranties</h3>
              <p>Rocket On Time warrants that:</p>
              <ul>
                <li>Services will be performed with reasonable care and skill.</li>
                <li>Deliverables will materially conform to the specifications in the applicable SOW.</li>
                <li>We have the authority to enter into and perform under these Terms.</li>
              </ul>

              <h3>7.2 Disclaimers</h3>
              <p>EXCEPT AS EXPRESSLY PROVIDED ABOVE, ALL SERVICES AND DELIVERABLES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.</p>
            </div>

            <div className="legal-section" id="liability">
              <h2>8. Limitation of Liability</h2>
              <p>To the maximum extent permitted by applicable law:</p>
              <ul>
                <li>Rocket On Time's total liability for any claim arising under these Terms shall not exceed the total fees paid by you in the 12 months preceding the claim.</li>
                <li>Neither party shall be liable for indirect, incidental, special, consequential, or punitive damages.</li>
                <li>These limitations apply regardless of the form of action, whether in contract, tort, or otherwise.</li>
              </ul>
            </div>

            <div className="legal-section" id="termination">
              <h2>9. Termination</h2>
              <p>Either party may terminate an engagement:</p>
              <ul>
                <li><strong>For Cause:</strong> Immediately upon written notice if the other party materially breaches these Terms and fails to cure within 30 days of notice.</li>
                <li><strong>For Convenience:</strong> With 30 days written notice. Client shall pay for all work completed through the termination date.</li>
              </ul>
              <p>Upon termination, Rocket On Time will deliver all completed work and you will pay all outstanding amounts. Provisions that by their nature should survive termination (IP, confidentiality, payment) shall survive.</p>
            </div>

            <div className="legal-section" id="governing">
              <h2>10. Governing Law & Dispute Resolution</h2>
              <p>These Terms shall be governed by the laws of the State of Maharashtra, India, without regard to conflict of law principles.</p>
              <p>Any disputes arising from these Terms shall be resolved through:</p>
              <ul>
                <li><strong>Step 1:</strong> Good-faith negotiation between senior representatives of both parties (30 days).</li>
                <li><strong>Step 2:</strong> Mediation through a mutually agreed mediator in Pune, Maharashtra.</li>
                <li><strong>Step 3:</strong> Binding arbitration under the Indian Arbitration and Conciliation Act, 1996, in Pune.</li>
              </ul>
              <p>The courts of Pune, Maharashtra shall have exclusive jurisdiction for any matters not subject to arbitration.</p>

              <div className="legal-contact" style={{ marginTop: '2rem' }}>
                <p><strong>For legal inquiries, contact:</strong></p>
                <p>Rocket On Time Legal Department<br />
                legal@gotechnology.in<br />
                +91 90999 09090</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
